import * as React from 'react';
import { useEffect, useState } from "react";
import TopCompareProduct from './ProductCompare/TopCompareProduct/TopCompareProduct';
import CompareProductTable from './ProductCompare/CompareProductTable';
import BackToProduct from './ProductCompare/BackToProduct';
import ProductCompareMiniSlider from "../component/Product/BottomCompareProduct/ProductCompareMiniSlider";
import AlertContentWithFlag from './Checkout/AlertContentWithFlag';
import SystemAlerts from 'src/component/SystemAlerts';
import { __set } from 'src/store/axios_indicator';
import useReduxState from 'src/hooks/useReduxState';
import yellowAlert from "src/assets/images/yellow-alert.png";

export function ProductCompare() {

    const [showError, setShowError] = useState(false)
    // const [showNoProductError, setNoProductError] = useState(false)
    const [showNoProductError, setNoProductError] = useReduxState(false, 'setNoProductError');
    useEffect(() => {
        __set('PRODUCT_COMPARE_API_CALL');
    }, [])


    return (
        <>
            <div>
                <div className="copmare-product-page">
                    <SystemAlerts />
                    {showError &&
                        <div className="container">
                            <div className="row mt-2">
                                <div className={'col-lg-12 p-0'}>
                                    <div className="alert alert-warning fade in mb-2">
                                        <span>Be aware that the products selected do not have the same technical characteristics so may not be directly comparable.</span>
                                        <img className='ms-auto' src={yellowAlert} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="container-fluid maxw100">

                        <div className="bs5 row">
                            <div className="col-12">
                                <BackToProduct />
                            </div>
                        </div>
                        <div className="bs5 row">
                            <div className="col-12">
                                <h3>Compare Products</h3>
                            </div>
                        </div>

                        <TopCompareProduct />

                        {showNoProductError &&
                            <div className='text-center'>
                                <AlertContentWithFlag message={'<b>There are no compare products for this account.</b>'} type="info" isDisplay={false} isDisplayIcon={false} />
                            </div>
                        }
                        <CompareProductTable setShowError={setShowError} setNoProductError={setNoProductError} />


                    </div>
                </div>

            </div>
            <ProductCompareMiniSlider hideCompareSlider={true} />
        </>
    );

}
